export default "__VITE_ASSET__D26tu1ya__"